export const baseUrl = '/registration-documents'
export const billingLocationBaseUrl = '/registration-documents-billing-location'
